export default {
  noRecords: 'No recent records found.',
} as const;
